<template>
<div>
  <div><b-button v-if="!show" @click="show = true">Zobrazit graf</b-button></div>
  <div v-if="show">
    <strong><span v-if="isInEur">€</span><span v-else>CZK</span>/MWh</strong>
    <bar :key="refreshKey" :chartdata="chartData" :options="chartOptions" :height="250" />
  </div>
</div>
</template>

<script>
import Bar from '@/components/charts/BarChart';
import { mapGetters } from 'vuex';
import _ from 'lodash';

const createCalculateBarColorFn = activeHours => (args) => {
  const colors = ['rgb(55,156,44)', 'rgb(164,32,32)', 'rgb(239,190,53)', 'rgb(8,109,243)']
  const other = 'rgb(208,208,208)';

  const hourValue = activeHours[args.dataIndex];
  if (hourValue !== undefined) {
    if (hourValue === true) {
      return 'rgb(55,156,44)'; // for backward compatibility of boolean type. Remove in the future.
    }
    return colors[hourValue - 1] || 'rgb(55,156,44)';
  }
  return other;
};

export default {
  name: 'OTEPriceChart',
  props: {
    actor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: false,
      refreshKey: 'chart-key',
    };
  },
  computed: {
    ...mapGetters([
      'getOTEPriceChartObject',
    ]),
    ...mapGetters('app', [
      'isConnectionOk',
    ]),
    varsTreeReal() {
      return this.getOTEPriceChartObject(this.actor);
    },
    isInEur() {
      return this.varsTreeReal.eur;
    },
    maxValue() {
      return Math.ceil(
        (Math.max(...this.varsTreeReal.values.map(value => value.price.value)) + 100) / 100,
      ) * 100;
    },
    chartOptions() {
      return {
        responsive: true,
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          xAxes: [{
            gridLines: {
              offsetGridLines: false,
              display: false,
            },
          }],
          yAxes: [{
            ticks: {
              max: this.maxValue,
            },
          }],
        },
      };
    },
    chartData() {
      const activeHours = {};
      this.varsTreeReal.values.forEach((value, index) => {
        if (value.hourOn.value) {
          activeHours[index] = value.hourOn.value;
        }
      });

      return {
        labels: this.varsTreeReal.values.map((value) => {
          let lbl_value = value.hourAct.value;
          if (value.hourAct.value > 23) {
            lbl_value = value.hourAct.value - 24;
          }
          if (lbl_value === 0) {
            lbl_value = 24;
          }
          return lbl_value;
        }),
        datasets: [{
          backgroundColor: createCalculateBarColorFn(activeHours),
          barPercentage: 1,
          categoryPercentage: 1,
          hoverBackgroundColor: '#89ede6',
          data: this.varsTreeReal.values.map(value => value.price.value),
          fill: {
            disabled: false,
          },
        }],
      };
    },
  },
  components: {
    Bar,
  },
};
</script>

<style scoped></style>
